"use strict";
"use client";
/*
 * Membrane React package
 * {@link https://www.npmjs.com/package/@membranehq/react}
 * v0.29.2
 */
'use client';

import { RadioGroup } from '@ark-ui/react/radio-group';
export { RadioGroupContext as Context, RadioGroupItemHiddenInput as ItemHiddenInput } from '@ark-ui/react/radio-group';
import { withSlotScopeClasses } from '../../helpers/scoped-slots.mjs';
import { tv } from 'tailwind-variants';
import { createSlotRecipeContext } from './utils/create-slot-recipe-context.mjs';

const radioGroupRecipe = tv({
  slots: withSlotScopeClasses("radioGroup", {
    root: "flex data-[orientation=vertical]:flex-col data-[orientation=horizontal]:flex-row",
    indicator: "",
    itemControl: [
      "bg-transparent border border-border-default rounded-full",
      "transition-[background] duration-200",
      "hover:bg-bg-subtle",
      "data-[state=checked]:bg-neutral-default data-[state=checked]:border-neutral-default",
      "data-[state=checked]:hover:bg-neutral-default",
      "data-[disabled]:border-border-disabled data-[disabled]:text-fg-disabled",
      "data-[disabled]:hover:bg-transparent data-[disabled]:hover:text-fg-disabled"
    ],
    item: "items-center cursor-pointer flex data-[disabled]:cursor-not-allowed",
    itemText: "text-fg-default font-medium data-[disabled]:text-fg-disabled",
    label: ""
  }),
  variants: {
    size: {
      sm: {
        root: "data-[orientation=vertical]:gap-3 data-[orientation=horizontal]:gap-4",
        item: "gap-2",
        itemControl: "w-4 h-4 data-[state=checked]:shadow-[inset_0_0_0_3px_var(--iap-colors-bg-default)]",
        itemText: "text-sm leading-5"
      },
      md: {
        root: "data-[orientation=vertical]:gap-4 data-[orientation=horizontal]:gap-6",
        item: "gap-3",
        itemControl: "w-5 h-5 data-[state=checked]:shadow-[inset_0_0_0_4px_var(--iap-colors-bg-default)]",
        itemText: "text-base leading-6"
      },
      lg: {
        root: "data-[orientation=vertical]:gap-5 data-[orientation=horizontal]:gap-8",
        item: "gap-4",
        itemControl: "w-6 h-6 data-[state=checked]:shadow-[inset_0_0_0_5px_var(--iap-colors-bg-default)]",
        itemText: "text-lg leading-7"
      }
    }
  },
  defaultVariants: {
    size: "md"
  }
});
const { withProvider, withContext } = createSlotRecipeContext(radioGroupRecipe);
withProvider(RadioGroup.RootProvider, "root");
const Root = withProvider(RadioGroup.Root, "root");
withContext(
  RadioGroup.Indicator,
  "indicator"
);
const ItemControl = withContext(
  RadioGroup.ItemControl,
  "itemControl"
);
const Item = withContext(RadioGroup.Item, "item");
const ItemText = withContext(
  RadioGroup.ItemText,
  "itemText"
);
withContext(
  RadioGroup.Label,
  "label"
);

export { Item, ItemControl, ItemText, Root };
